export const es = {
    translation: {
        b: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            send: 'Enviar',
            done: 'Listo',
            close: 'Cerrar',
            clear: 'Limpiar',
            copy_link: 'Copiar enlace',
            export: 'Exportar',
            delete: 'Eliminar',
            delete_confirm: 'Confirmar eliminación',
            duplicate: 'Duplicar',
            share: 'Compartir',
            sign_in: 'Iniciar sesión',
            sign_up: 'Registrarse',
            email_address: 'Correo electrónico',
            yes: 'Sí',
            no: 'No'
        },
        m_languages: {
            title: 'Idiomas',
            subtitle: 'Elige un idioma'
        },
        m_feedback: {
            feature: {
                name: 'Solicitud de función',
                desc: '¿Falta alguna función que necesitas? Cuéntanos — tus ideas importan'
            },
            feedback: {
                name: 'Comentarios',
                desc: 'Tus comentarios son muy importantes para nosotros — deja una nota breve'
            }
        },
        m_feedback_t: {
            feature: {
                name: '¡Gracias por tu sugerencia!',
                desc: 'Agradecemos de verdad que te tomes el tiempo para compartir tus ideas — nos ayuda a mejorar.'
            },
            feedback: {
                name: '¡Gracias por tus comentarios!',
                desc: 'Agradecemos de verdad que te tomes el tiempo para compartir tus ideas — nos ayuda a mejorar.'
            }
        },
        m_diagram_details: {
            name_place: 'Introduce el nombre del proyecto',
            desc_place: 'Introduce la descripción del proyecto'
        },
        m_quick_share: {
            title: 'Compartir rápido',
            subtitle: '(Por enlace)'
        },
        m_export_img: {
            title: 'Exportar imagen'
        },
        m_export_code: {
            title: 'Exportar código {{db_engine}}',
            download_file: 'Descargar archivo',
            copy_code: 'Copiar código'
        },
        m_sign_in_remind: {
            title: 'Gracias por probar DB Design',
            subtitle: 'Inicia sesión o regístrate para aumentar el número máximo de tablas, guardar diagramas y desbloquear más funciones.'
        },
        m_sign_in_restrict: {
            title: 'Inicia sesión para hacer más en la app',
            subtitle: 'Inicia sesión o regístrate para aumentar los límites de tablas, guardar diagramas y desbloquear más funciones.'
        },
        m_new_diagram: {
            title: 'Nuevo diagrama',
            subtitle: 'Elige un motor de base de datos',
            open_diagram: 'Abrir diagrama'
        },
        m_keyboard_shortcuts: {
            title: 'Atajos de teclado',
            ctrl_left: {
                title1: 'Controles',
                title2: '(Izquierda)',
                items: {
                    mouse_sel: 'Selección con mouse / Modo mano',
                    table: 'Tabla',
                    line: 'Línea',
                    area: 'Área',
                    note: 'Nota',
                    comment: 'Comentario',
                    pen: 'Lápiz',
                    undo: 'Deshacer',
                    redo: 'Rehacer'
                }
            },
            ctrl_top_left: {
                title1: 'Controles',
                title2: '(Arriba a la izquierda)',
                items: {
                    export_img: 'Exportar imagen',
                    search: 'Buscar',
                    editor_panel: 'Panel del editor'
                }
            },
            ctrl_bottom_right: {
                title1: 'Controles',
                title2: '(Abajo a la derecha)',
                items: {
                    minimap: 'Minimapa',
                    zoom_in: 'Acercar',
                    zoom_out: 'Alejar',
                    zoom_100: 'Zoom al 100 %'
                }
            },
            ctx_tab: {
                title1: 'Menú contextual',
                title2: '(Tabla)',
                items: {
                    dupl_tab: 'Duplicar tabla',
                    del_tab: 'Eliminar tabla'
                }
            },
            ctx_del_tab: {
                title1: 'Menú contextual',
                title2: '(Eliminar tabla)',
                items: {
                    yes: 'Sí',
                    no: 'No'
                }
            },
            ctx_tab_col: {
                title1: 'Menú contextual',
                title2: '(Columna)', // Columna de tabla
                items: {
                    add_col_below: 'Agregar nueva columna debajo',
                    focus_col_above: 'Foco en la columna superior',
                    focus_col_below: 'Foco en la columna inferior',
                    move_col_up: 'Mover columna arriba',
                    move_col_down: 'Mover columna abajo',
                    dupl_col: 'Duplicar columna',
                    del_col: 'Eliminar columna'
                }
            },
            ctx_line: {
                title1: 'Menú contextual',
                title2: '(Línea)',
                items: {
                    del_line: 'Eliminar línea'
                }
            },
            ctx_area: {
                title1: 'Menú contextual',
                title2: '(Área)',
                items: {
                    dupl_area: 'Duplicar área',
                    del_area: 'Eliminar área'
                }
            },
            ctx_multi: {
                title1: 'Menú contextual',
                title2: '(Multiselección)',
                items: {
                    select_all: 'Seleccionar todos los elementos',
                    create_area_for_select_els: 'Crear área para los elementos seleccionados',
                    dupl_select_els: 'Duplicar elementos seleccionados',
                    del_select_els: 'Eliminar elementos seleccionados'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Selección con mouse',
                table: 'Tabla',
                line: 'Línea',
                area: 'Área',
                note: 'Nota (próximamente)',
                comment: 'Comentario (próximamente)',
                pen: 'Lápiz',
                undo: 'Deshacer',
                redo: 'Rehacer'
            },
            ctrl_top_left: {
                logo: 'Nota: este es un entorno de pruebas',
                name: 'Información del diagrama',
                editor: 'Editor (próximamente)',
                search: 'Búsqueda (próximamente)',
                export: 'Opciones de exportación',
                view_mode: 'Modo de visualización',
                zoom_to_fit: 'Ajustar a la pantalla'
            },
            ctrl_top_right: {
                feature_req: 'Solicitud de función',
                sign_in: 'Iniciar sesión',
                quick_share: 'Compartir rápido'
            },
            ctrl_bottom_right: {
                full_screen: 'Pantalla completa',
                minimap: 'Minimapa',
                zoom_out: 'Alejar',
                zoom_100: 'Zoom al 100 %',
                zoom_in: 'Acercar',
                info: 'Información y recursos'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Predeterminado',
                        blue: 'Azul',
                        green: 'Verde',
                        red: 'Rojo',
                        purple: 'Morado',
                        violet: 'Violeta'
                    },
                    borders: {
                        none: 'Ninguno',
                        solid: 'Sólido',
                        dashed: 'Discontinuo',
                        dotted: 'Punteado'
                    },
                    color: 'Color',
                    border: 'Borde',
                    description: 'Descripción',
                    description_table_place: 'Descripción de la tabla',
                    description_column_place: 'Descripción de la columna',
                    description_line_place: 'Descripción de la línea',
                    description_note_place: 'Descripción de la nota',
                    description_area_place: 'Descripción del campo',
                    description_pen_place: 'Descripción del lápiz',
                    hide_menu: 'Ocultar menú',
                    show_menu: 'Mostrar menú'
                },
                tab_col: {
                    add_col_below: 'Agregar columna debajo',
                    add_col_above: 'Agregar columna encima',
                    key: 'Key',
                    keys: {
                        none: 'Ninguna',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Ninguno',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Mover columna abajo',
                    move_col_up: 'Mover columna arriba',
                    more_functions: 'Más funciones'
                },
                line: {
                    change_connects: 'Cambiar conectores',
                    connects: {
                        empty: 'Vacío',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtrar elementos'
                },
                multi: {
                    filter: 'Filtrar selección',
                    create_area: 'Crear área'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Solo claves',
            names_only: 'Solo nombres'
        },
        dropdown_ctrl_export: {
            export_img: 'Exportar imagen',
            export_code: 'Exportar código SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Iniciar sesión',
            new_project: 'Nuevo proyecto',
            keyboard_shortcuts: 'Atajos de teclado',
            languages: 'Idiomas'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Comentarios',
            keyboard_shortcuts: 'Atajos de teclado',
            languages: 'Idiomas',
            homepage: 'Página de inicio'
        },
        n: {
            default: 'Cargando…',
            file_ready_to_download: 'El archivo está listo para descargar',
            code_copied: 'El código se ha copiado',
            link_copied: 'El enlace se ha copiado',
            please_enter_message: 'Por favor, introduce un mensaje',
            invalid_email: 'El correo electrónico no es válido',
            something_wrong_contact: 'Se produjo un error. Recarga la página o contáctanos.',
            something_wrong: 'Se produjo un error. Recarga la página.',
            sending: 'Enviando…',
            request_sent: 'Solicitud enviada. ¡Gracias!'
        }
    }
};

export const esMeta = {
    lang_origin: 'Español',
    lang_eng: 'Spanish',
    lang_code: 'es',
};
